import { createContext, useContext, useState } from 'react';

// ── Mock Users ────────────────────────────────────────────────
export const TRAINING_USERS = [
  { id: 'u1', name: 'Manzil Zaheer', role: 'admin',   initials: 'MZ', title: 'Platform Admin'        },
  { id: 'u2', name: 'Sarah Chen',    role: 'learner', initials: 'SC', title: 'Sales Representative'  },
  { id: 'u3', name: 'James Rivera',  role: 'learner', initials: 'JR', title: 'Operations Manager'    },
  { id: 'u4', name: 'Priya Nair',    role: 'learner', initials: 'PN', title: 'HR Manager'            },
];

const TrainingContext = createContext(null);

export function TrainingProvider({ children }) {
  const [trainingUser, setTrainingUser] = useState(TRAINING_USERS[0]);

  return (
    <TrainingContext.Provider value={{ trainingUser, setTrainingUser, TRAINING_USERS }}>
      {children}
    </TrainingContext.Provider>
  );
}

export function useTrainingUser() {
  const ctx = useContext(TrainingContext);
  if (!ctx) throw new Error('useTrainingUser must be used inside <TrainingProvider>');
  return ctx;
}
